import { Component, OnInit, ViewChild } from "@angular/core";
import { AuthService, FirebaseService } from "src/app/core";
import { MdbTableDirective } from "ng-uikit-pro-standard";
import { ProductFilterService } from "src/app/core/services/filter.service";
import { ProductStatus } from "src/app/core/product/enums/product-status.enum";
import { Router } from "@angular/router";
import { Product } from "src/app/core/product/product";
import { ScheduleType, ProductType } from "src/app/core/product/enums";

@Component({
  selector: "ll-passes-table",
  templateUrl: "./passes-table.component.html",
  styleUrls: ["./passes-table.component.scss"]
})
export class PassesTableComponent implements OnInit {
  @ViewChild(MdbTableDirective, { static: true }) mdbTable: MdbTableDirective;
  data: Product[];
  constructor(
    private auth: AuthService,
    public fb: FirebaseService,
    public router: Router
  ) {}
  ngOnInit() {}

  ngAfterViewInit() {}

  openAddPass() {
    this.fb.venue.initBuilder();
  }

  show(i: number) {
    return this.filter.show(i);
  }
  increment() {
    this.filter.increment();
  }
  decrement() {
    this.filter.decrement();
  }
  setItemsPerPage(item: number) {
    this.filter.showing = item;
    this.filter.firstIndex = 0;
    this.filter.lastIndex = item;
    this.mdbTable.setDataSource(this.data);
  }

  schedule_mask = (type: ScheduleType) => {
    switch (type) {
      case ScheduleType.Continuous:
        return "Continuous";
      case ScheduleType.CustomDays:
        return "Custom Days";
      case ScheduleType.DayOfWeek:
        return "Day of Week";
    }
  };

  getType(i: number): string {
    return ProductType[i];
  }
  get filter(): ProductFilterService {
    return this.fb.venue.filter;
  }
  get passes(): Product[] {
    return this.filter.filtered;
  }
  get toPassForm(): string[] {
    return ["pass-form"];
  }
  get toScheduleForm(): string[] {
    return ["schedule-form"];
  }
  isError(pass: Product) {
    return ![ProductStatus.Active, ProductStatus.Staged].includes(pass.status);
  }
  isHidden(pass: Product): boolean {
    return !pass.isActive;
  }
  details(pass: Product) {
    this.fb.venue.initBuilder(pass);
  }
  schedule(pass: Product) {
    this.fb.venue.initBuilder(pass);
  }
}
